export default __webpack_public_path__ + "static/N0255-17ca4aec843a03774af59fec71130aba.png";